import { render } from "./RelatorioVendaPorProduto.vue?vue&type=template&id=1d179774&ts=true"
import script from "./RelatorioVendaPorProduto.vue?vue&type=script&lang=ts"
export * from "./RelatorioVendaPorProduto.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__